module.exports = __webpack_public_path__ + "static/media/MITC.91e89639.jpg";